var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-shrink-0 overflow-y-auto overflow-x-hidden"
  }, [_c('div', {
    staticClass: "min-h-screen flex flex-col bg-indigo-600 transition-all duration-100 ease-in relative z-20",
    class: {
      'max-w-max w-72 2xl:w-80': _vm.isFullMenu
    }
  }, [_c('div', {
    staticClass: "h-0 flex-1 flex flex-col pt-10 overflow-y-auto"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.$emit('changePage');
      }
    }
  }, [_c('router-link', {
    staticClass: "flex items-center flex-shrink-0 px-6",
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "title": "Accueil"
    }
  }, [_c('icon', {
    class: 'text-white transition ease-in-out duration-150 ' + (_vm.isFullMenu ? '' : 'hidden'),
    attrs: {
      "name": "logo-neopass-dark"
    }
  }), _vm._v(" "), _c('icon', {
    class: _vm.isFullMenu ? 'hidden' : '',
    attrs: {
      "name": "logo-neopass-dark-reduce",
      "label": "Accueil"
    }
  }), _vm._v(" "), _vm.$freeParticulier() ? _c('beta-tag') : _vm._e()], 1)], 1), _vm._v(" "), _c('nav', {
    staticClass: "mt-16 flex-1"
  }, _vm._l(_vm.listPages, function (page) {
    return _c('div', {
      key: page.name,
      on: {
        "click": function ($event) {
          _vm.SET_MSGPREMIUM('');
          _vm.$emit('changePage');
        }
      }
    }, [_c('MenuLink', {
      attrs: {
        "page": page,
        "current-page": _vm.currentPage,
        "is-full-menu": _vm.isFullMenu
      }
    })], 1);
  }), 0)]), _vm._v(" "), _vm.currentPage === '/' && _vm.$can('dashboard_custom') ? _c('div', {
    staticClass: "flex-shrink-0 flex tour_customizedashboard"
  }, [_c('router-link', {
    staticClass: "my-3 flex items-center py-4 px-6 text-xs focus:outline-none transition ease-in-out duration-150",
    attrs: {
      "to": {
        name: 'CustomizeDashboard'
      }
    }
  }, [_c('div', {
    staticClass: "mr-4 p-3 rounded-full bg-indigo-100 border-2 border-pink-600 text-indigo-600 hover:text-indigo-300 focus:text-indigo-300 hover:bg-indigo-600"
  }, [_c('icon', {
    staticClass: "h-8 w-8 transition ease-in-out duration-150",
    attrs: {
      "name": "options"
    }
  })], 1), _vm._v(" "), _c('p', {
    class: (_vm.isFullMenu ? '' : 'hidden') + ' ml-4 pt-1 text-white'
  }, [_vm._v("\n          Personnaliser"), _c('br'), _vm._v("mon dashboard\n        ")])])], 1) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }